import { render, staticRenderFns } from "./Broadcaster.vue?vue&type=template&id=4a9b5fce&"
import script from "./Broadcaster.vue?vue&type=script&lang=js&"
export * from "./Broadcaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports